var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoplaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 512 152",
    width: "512pt",
    height: "152pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_txKZwF55gfIAEx7GSH7BgmGYRUw23akE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 152
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_txKZwF55gfIAEx7GSH7BgmGYRUw23akE)"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 493.06 151.78 L 18.94 151.78 C 8.56 151.78 0 143.22 0 132.84 L 0 19.08 C 0 8.7 8.56 0.14 18.94 0.14 L 493.07 0.14 C 503.45 0.14 512.01 8.7 512.01 19.08 L 512.01 132.84 C 512 143.22 503.44 151.78 493.06 151.78 Z ",
    fill: "rgb(0,0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 493.06 3.09 C 501.9 3.09 509.05 10.24 509.05 19.08 L 509.05 132.84 C 509.05 141.68 501.9 148.83 493.06 148.83 L 18.94 148.83 C 10.1 148.83 2.95 141.68 2.95 132.84 L 2.95 19.08 C 2.95 10.24 10.1 3.09 18.94 3.09 L 493.06 3.09 Z  M 493.06 0 L 18.94 0 C 8.56 0 0 8.56 0 18.94 L 0 132.7 C 0 143.08 8.56 151.64 18.94 151.64 L 493.07 151.64 C 503.45 151.64 512.01 143.08 512.01 132.7 L 512.01 18.94 C 512 8.56 503.44 0 493.06 0 Z ",
    fill: "rgb(166,166,166)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 179.83 38.86 C 179.83 42.09 178.85 44.61 177.02 46.43 C 174.92 48.67 172.11 49.8 168.6 49.8 C 165.37 49.8 162.57 48.68 160.18 46.43 C 157.94 44.19 156.67 41.38 156.67 38.01 C 156.67 34.64 157.79 31.84 160.18 29.59 C 162.42 27.35 165.23 26.22 168.6 26.22 C 170.28 26.22 171.83 26.5 173.23 27.2 C 174.77 27.9 175.9 28.74 176.74 29.72 L 174.78 31.68 C 173.24 29.86 171.13 29.01 168.61 29.01 C 166.23 29.01 164.12 29.85 162.44 31.53 C 160.76 33.21 159.77 35.46 159.77 38.12 C 159.77 40.78 160.61 43.03 162.44 44.71 C 164.12 46.39 166.23 47.23 168.61 47.23 C 171.13 47.23 173.24 46.39 174.92 44.71 C 176.04 43.59 176.6 42.04 176.88 40.08 L 168.6 40.08 L 168.6 37.41 L 179.68 37.41 C 179.83 37.74 179.83 38.3 179.83 38.86 Z ",
    fill: "rgb(255,255,255)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 179.83 38.86 L 179.83 38.86 C 179.69 41.95 178.71 44.47 176.88 46.29 L 176.88 46.29 L 176.88 46.29 C 174.78 48.53 171.97 49.66 168.6 49.66 C 165.37 49.66 162.57 48.54 160.32 46.29 C 158.08 44.05 156.95 41.24 156.95 37.87 C 156.95 34.5 158.07 31.7 160.32 29.45 C 162.56 27.21 165.37 26.08 168.6 26.08 C 170.14 26.08 171.69 26.36 173.23 27.06 C 174.63 27.62 175.9 28.46 176.74 29.58 L 176.88 29.44 L 176.74 29.3 L 174.78 31.26 L 174.92 31.4 L 175.06 31.26 C 173.52 29.44 171.41 28.45 168.75 28.45 C 166.37 28.45 164.26 29.29 162.44 30.97 C 160.62 32.65 159.77 34.9 159.77 37.7 C 159.77 40.37 160.61 42.61 162.44 44.43 C 164.26 46.11 166.37 46.95 168.75 46.95 C 171.27 46.95 173.52 46.11 175.2 44.43 C 176.32 43.31 177.02 41.76 177.16 39.8 L 177.16 39.66 L 168.88 39.66 L 168.88 37.28 L 179.82 37.28 L 179.82 37.14 L 179.68 37.14 C 179.69 37.74 179.69 38.3 179.83 38.86 L 179.83 38.86 L 179.97 38.86 C 179.97 38.3 179.97 37.74 179.83 37.18 L 179.83 37.04 L 168.61 37.04 L 168.61 39.99 L 177.03 39.99 L 177.03 39.85 L 176.89 39.85 C 176.75 41.81 176.05 43.36 175.07 44.34 C 173.39 46.02 171.28 46.86 168.76 46.86 C 166.38 46.86 164.41 46.02 162.59 44.34 C 160.91 42.66 160.07 40.55 160.07 37.89 C 160.07 35.22 160.91 33.12 162.59 31.44 C 164.27 29.76 166.38 28.92 168.76 28.92 C 171.43 28.92 173.39 29.76 174.93 31.59 L 175.07 31.73 L 177.31 29.49 L 177.17 29.35 C 176.33 28.23 175.07 27.39 173.52 26.83 C 171.98 26.13 170.43 25.85 168.75 25.85 C 165.38 25.85 162.58 26.97 160.33 29.36 C 157.95 31.6 156.82 34.55 156.82 37.92 C 156.82 41.29 157.94 44.23 160.33 46.48 C 162.71 48.72 165.52 49.99 168.75 49.99 C 172.26 49.99 175.06 48.87 177.17 46.62 L 177.03 46.48 L 177.17 46.62 C 179.13 44.61 179.97 42.08 179.83 38.86 L 179.83 38.86 L 179.83 38.86 Z ",
    fill: "rgb(255,255,255)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 197.37 29.32 L 186.99 29.32 L 186.99 36.61 L 196.24 36.61 L 196.24 39.28 L 186.99 39.28 L 186.99 46.57 L 197.37 46.57 L 197.37 49.38 L 184.04 49.38 L 184.04 26.65 L 197.37 26.65 L 197.37 29.32 Z ",
    fill: "rgb(255,255,255)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: " M 197.37 29.32 L 197.37 29.18 L 186.84 29.18 L 186.84 36.75 L 196.1 36.75 L 196.1 39.14 L 186.84 39.14 L 186.84 46.71 L 197.23 46.71 L 197.23 49.24 L 184.18 49.24 L 184.18 26.79 L 197.23 26.79 L 197.23 29.32 L 197.37 29.32 L 197.37 29.18 L 197.37 29.32 L 197.51 29.32 L 197.51 26.51 L 183.9 26.51 L 183.9 49.52 L 197.51 49.52 L 197.51 46.43 L 187.13 46.43 L 187.13 39.42 L 196.38 39.42 L 196.38 36.47 L 187.13 36.47 L 187.13 29.46 L 197.51 29.46 L 197.51 29.32 L 197.37 29.32 Z ",
    fill: "rgb(255,255,255)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: " M 209.71 49.38 L 206.76 49.38 L 206.76 29.32 L 200.31 29.32 L 200.31 26.65 L 216.02 26.65 L 216.02 29.32 L 209.71 29.32 L 209.71 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: " M 209.71 49.38 L 209.71 49.24 L 206.9 49.24 L 206.9 29.18 L 200.45 29.18 L 200.45 26.79 L 215.88 26.79 L 215.88 29.18 L 209.57 29.18 L 209.57 49.38 L 209.71 49.38 L 209.71 49.24 L 209.71 49.38 L 209.85 49.38 L 209.85 29.46 L 216.16 29.46 L 216.16 26.51 L 200.17 26.51 L 200.17 29.46 L 206.62 29.46 L 206.62 49.52 L 209.85 49.52 L 209.85 49.38 L 209.71 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 227.38,
    y: 26.65,
    width: 2.95,
    height: 22.72,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: " M 227.38 49.38 L 227.52 49.38 L 227.52 26.79 L 230.05 26.79 L 230.05 49.24 L 227.38 49.24 L 227.38 49.38 L 227.52 49.38 L 227.38 49.38 L 227.38 49.52 L 230.33 49.52 L 230.33 26.51 L 227.24 26.51 L 227.24 49.52 L 227.38 49.52 L 227.38 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: " M 243.24 49.38 L 240.29 49.38 L 240.29 29.32 L 233.98 29.32 L 233.98 26.65 L 249.55 26.65 L 249.55 29.32 L 243.24 29.32 L 243.24 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: " M 243.24 49.38 L 243.24 49.24 L 240.43 49.24 L 240.43 29.18 L 234.12 29.18 L 234.12 26.79 L 249.41 26.79 L 249.41 29.18 L 243.09 29.18 L 243.09 49.38 L 243.24 49.38 L 243.24 49.24 L 243.24 49.38 L 243.38 49.38 L 243.38 29.46 L 249.69 29.46 L 249.69 26.51 L 233.84 26.51 L 233.84 29.46 L 240.15 29.46 L 240.15 49.52 L 243.38 49.52 L 243.38 49.38 L 243.24 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: " M 279.15 46.43 C 276.91 48.67 274.1 49.94 270.87 49.94 C 267.5 49.94 264.7 48.82 262.59 46.43 C 260.35 44.19 259.22 41.38 259.22 38.01 C 259.22 34.64 260.34 31.84 262.59 29.59 C 264.83 27.35 267.64 26.08 270.87 26.08 C 274.24 26.08 276.9 27.2 279.15 29.59 C 281.39 31.83 282.52 34.64 282.52 38.01 C 282.51 41.24 281.39 44.05 279.15 46.43 Z  M 264.7 44.47 C 266.38 46.15 268.49 46.99 270.87 46.99 C 273.25 46.99 275.36 46.15 277.04 44.47 C 278.72 42.79 279.56 40.54 279.56 37.88 C 279.56 35.21 278.72 33.11 277.04 31.29 C 275.36 29.61 273.25 28.77 270.87 28.77 C 268.49 28.77 266.38 29.61 264.7 31.29 C 263.02 32.97 262.18 35.22 262.18 37.88 C 262.17 40.54 263.01 42.79 264.7 44.47 Z ",
    fill: "rgb(255,255,255)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: " M 279.15 46.43 L 279.15 46.43 C 276.91 48.67 274.1 49.8 270.87 49.8 C 267.64 49.8 264.84 48.68 262.59 46.43 C 260.35 44.19 259.22 41.38 259.22 38.15 C 259.22 34.92 260.34 32.12 262.59 29.87 C 264.83 27.63 267.5 26.5 270.87 26.5 C 274.1 26.5 276.9 27.62 279.15 29.87 C 281.39 32.11 282.52 34.92 282.52 38.15 C 282.37 41.24 281.25 44.05 279.15 46.43 L 279.15 46.43 L 279.15 46.43 C 281.53 44.19 282.66 41.38 282.66 38.01 C 282.66 34.64 281.54 31.84 279.29 29.45 C 277.05 27.07 274.24 25.94 270.87 25.94 C 267.5 25.94 264.7 27.06 262.45 29.45 C 260.2 31.84 259.08 34.64 259.08 38.01 C 259.08 41.38 260.2 44.18 262.45 46.57 C 264.69 48.95 267.5 50.08 270.87 50.08 C 274.24 49.94 277.04 48.82 279.15 46.43 L 279.15 46.43 Z  M 264.7 44.47 L 264.7 44.47 C 266.24 46.29 268.35 47.14 270.87 47.14 C 273.39 47.14 275.5 46.3 277.18 44.47 C 278.86 42.79 279.7 40.54 279.7 37.88 C 279.7 35.21 278.86 32.97 277.18 31.29 C 275.5 29.61 273.39 28.62 270.87 28.62 C 268.35 28.62 266.24 29.46 264.56 31.29 C 262.88 32.97 262.04 35.22 262.04 37.88 C 262.03 40.68 262.87 42.93 264.7 44.47 L 264.7 44.47 L 264.7 44.47 C 263.16 42.65 262.32 40.54 262.32 37.88 C 262.32 35.21 263.16 33.11 264.84 31.43 C 266.52 29.75 268.49 28.91 270.87 28.91 C 273.25 28.91 275.36 29.75 276.9 31.43 C 278.58 33.11 279.42 35.22 279.42 37.88 C 279.42 40.55 278.58 42.65 276.9 44.33 C 275.22 46.01 273.25 46.85 270.87 46.85 C 268.48 46.85 266.38 46.01 264.7 44.47 L 264.7 44.47 Z ",
    fill: "rgb(255,255,255)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: " M 286.58 49.38 L 286.58 26.65 L 290.23 26.65 L 301.31 44.33 L 301.31 44.33 L 301.31 39.84 L 301.31 26.65 L 304.11 26.65 L 304.11 49.38 L 301.17 49.38 L 289.53 30.72 L 289.39 30.72 L 289.53 35.21 L 289.53 49.38 L 286.58 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: " M 286.58 49.38 L 286.72 49.38 L 286.72 26.79 L 290.09 26.79 L 301.17 44.47 L 301.31 44.47 L 301.45 44.47 L 301.45 39.84 L 301.45 26.79 L 303.97 26.79 L 303.97 49.24 L 301.17 49.24 L 289.67 30.58 L 289.39 30.58 L 289.24 30.58 L 289.39 35.21 L 289.39 49.24 L 286.58 49.24 L 286.58 49.38 L 286.72 49.38 L 286.58 49.38 L 286.58 49.52 L 289.67 49.52 L 289.67 35.21 L 289.53 30.72 L 289.39 30.72 L 289.39 30.86 L 289.53 30.86 L 301.03 49.52 L 304.25 49.52 L 304.25 26.51 L 301.17 26.51 L 301.17 39.84 L 301.17 44.33 L 301.31 44.33 L 301.31 44.19 L 301.31 44.19 L 290.23 26.51 L 286.44 26.51 L 286.44 49.52 L 286.58 49.52 L 286.58 49.38 Z ",
    fill: "rgb(255,255,255)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: " M 258.38 82.48 C 249.4 82.48 242.25 89.21 242.25 98.61 C 242.25 107.87 249.54 114.74 258.38 114.74 C 267.36 114.74 274.51 107.87 274.51 98.61 C 274.66 89.36 267.36 82.48 258.38 82.48 Z  M 258.38 108.43 C 253.47 108.43 249.26 104.36 249.26 98.61 C 249.26 92.86 253.47 88.79 258.38 88.79 C 263.29 88.79 267.5 92.72 267.5 98.61 C 267.5 104.37 263.29 108.43 258.38 108.43 Z  M 223.04 82.48 C 214.06 82.48 206.91 89.21 206.91 98.61 C 206.91 107.87 214.2 114.74 223.04 114.74 C 232.02 114.74 239.17 107.87 239.17 98.61 C 239.31 89.36 232.01 82.48 223.04 82.48 Z  M 223.04 108.43 C 218.13 108.43 213.92 104.36 213.92 98.61 C 213.92 92.86 218.13 88.79 223.04 88.79 C 227.95 88.79 232.16 92.72 232.16 98.61 C 232.15 104.37 227.95 108.43 223.04 108.43 Z  M 181.09 87.53 L 181.09 94.4 L 197.5 94.4 C 197.08 98.19 195.68 100.99 193.71 102.96 C 191.33 105.34 187.54 108.01 181.09 108.01 C 170.99 108.01 163.13 99.87 163.13 89.77 C 163.13 79.67 170.99 71.53 181.09 71.53 C 186.56 71.53 190.49 73.63 193.43 76.44 L 198.2 71.67 C 194.13 67.74 188.66 64.8 181.09 64.8 C 167.34 64.8 155.7 76.02 155.7 89.91 C 155.7 103.66 167.34 115.02 181.09 115.02 C 188.52 115.02 194.14 112.64 198.62 108.01 C 203.11 103.52 204.51 97.07 204.51 92.02 C 204.51 90.48 204.37 88.93 204.09 87.81 L 181.09 87.81 L 181.09 87.53 L 181.09 87.53 Z  M 352.93 92.86 C 351.53 89.21 347.46 82.62 339.18 82.62 C 330.9 82.62 324.03 89.21 324.03 98.75 C 324.03 107.73 330.9 114.88 340.02 114.88 C 347.45 114.88 351.66 110.39 353.49 107.73 L 348.02 104.08 C 346.2 106.75 343.67 108.57 340.02 108.57 C 336.37 108.57 333.85 106.89 332.16 103.66 L 353.76 94.68 L 352.93 92.86 Z  M 330.91 98.19 C 330.77 92.02 335.68 88.79 339.33 88.79 C 342.14 88.79 344.52 90.19 345.36 92.16 L 330.91 98.19 Z  M 313.37 113.76 L 320.52 113.76 L 320.52 66.35 L 313.37 66.35 L 313.37 113.76 Z  M 301.73 86.13 L 301.45 86.13 C 299.91 84.17 296.82 82.48 292.89 82.48 C 284.89 82.48 277.46 89.63 277.46 98.61 C 277.46 107.59 284.89 114.74 292.89 114.74 C 296.68 114.74 299.76 113.06 301.45 111.09 L 301.73 111.09 L 301.73 113.47 C 301.73 119.64 298.36 123.01 293.17 123.01 C 288.82 123.01 286.16 119.92 285.03 117.26 L 278.86 119.78 C 280.68 123.99 285.31 129.32 293.17 129.32 C 301.45 129.32 308.46 124.41 308.46 112.49 L 308.46 83.59 L 301.73 83.59 L 301.73 86.13 L 301.73 86.13 Z  M 293.59 108.43 C 288.68 108.43 284.61 104.36 284.61 98.75 C 284.61 93 288.68 88.93 293.59 88.93 C 298.36 88.93 302.15 93.14 302.15 98.75 C 302.29 104.37 298.5 108.43 293.59 108.43 Z  M 386.17 66.35 L 369.2 66.35 L 369.2 113.76 L 376.21 113.76 L 376.21 95.8 L 386.03 95.8 C 393.89 95.8 401.6 90.19 401.6 81.07 C 401.6 72.1 393.89 66.35 386.17 66.35 Z  M 386.31 89.22 L 376.21 89.22 L 376.21 72.95 L 386.31 72.95 C 391.64 72.95 394.59 77.3 394.59 81.09 C 394.59 84.87 391.64 89.22 386.31 89.22 Z  M 430.08 82.48 C 424.89 82.48 419.7 84.72 417.46 89.77 L 423.77 92.44 C 425.17 89.77 427.56 88.93 430.22 88.93 C 433.87 88.93 437.65 91.17 437.65 94.96 L 437.65 95.38 C 436.39 94.68 433.58 93.56 430.22 93.56 C 423.49 93.56 416.61 97.35 416.61 104.22 C 416.61 110.53 422.22 114.6 428.39 114.6 C 433.16 114.6 435.82 112.5 437.37 109.97 L 437.65 109.97 L 437.65 113.62 L 444.52 113.62 L 444.52 95.39 C 444.39 87.11 438.08 82.48 430.08 82.48 Z  M 429.24 108.43 C 426.86 108.43 423.63 107.31 423.63 104.36 C 423.63 100.71 427.7 99.31 431.06 99.31 C 434.15 99.31 435.69 100.01 437.51 100.85 C 437.09 105.35 433.31 108.43 429.24 108.43 Z  M 469.36 83.46 L 461.22 104.08 L 460.94 104.08 L 452.52 83.46 L 444.95 83.46 L 457.57 112.22 L 450.42 128.21 L 457.85 128.21 L 477.35 83.46 L 469.36 83.46 L 469.36 83.46 Z  M 405.53 113.76 L 412.54 113.76 L 412.54 66.35 L 405.53 66.35 L 405.53 113.76 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_0",
    x1: 0.9130428902017038,
    y1: 0.04464434879758494,
    x2: -0.12128493149058328,
    y2: 1.0789721704898718,
    gradientTransform: "matrix(49.09,0,0,93.98,37.88,28.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,160,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.657445%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,161,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.009999999999998%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,190,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,210,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.03999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,223,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,227,255)"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: " M 37.87 33.25 L 37.87 33.25 L 37.87 33.25 Z  M 37.87 33.25 L 37.87 33.25 L 37.87 33.25 Z  M 39.84 28.9 C 38.58 30.02 37.88 31.99 37.88 34.51 L 37.88 33.95 C 37.88 33.67 37.88 33.53 37.88 33.25 C 37.88 33.53 37.88 33.67 37.88 33.95 L 37.88 117.83 L 37.88 117.27 C 37.88 119.65 38.58 121.48 39.7 122.6 L 39.98 122.88 L 86.97 75.89 L 39.84 28.9 Z ",
    fill: "url(#_lgradient_0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_1",
    x1: 1.0752374385691397,
    y1: 0.5000648454773859,
    x2: -1.3035339362363025,
    y2: 0.5000648454773856,
    gradientTransform: "matrix(38.58,0,0,31.84,86.83,60.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,224,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,189,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.53999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,165,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,156,0)"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: " M 124.84 78.13 C 124.28 79.39 123.02 80.51 121.47 81.36 L 102.95 91.88 L 102.53 92.02 L 102.53 92.02 L 102.95 91.88 L 121.47 81.36 C 123.02 80.38 124.28 79.26 124.84 78.13 Z  M 102.54 60.18 L 86.83 75.89 L 102.54 91.6 L 121.48 80.8 C 123.86 79.4 125.27 77.71 125.41 75.89 L 125.41 75.89 C 125.13 74.07 123.87 72.38 121.48 70.98 L 102.54 60.18 Z ",
    fill: "url(#_lgradient_1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_2",
    x1: 0.8631502108423563,
    y1: 0.17872116386573556,
    x2: -0.5010093485065421,
    y2: 1.5428807232146335,
    gradientTransform: "matrix(63.27,0,0,48.81,39.56,75.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,58,68)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(195,17,98)"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: " M 39.84 123.44 L 39.84 123.44 C 40.68 124.28 41.94 124.7 43.21 124.7 C 43.49 124.7 43.63 124.7 43.91 124.7 C 43.63 124.7 43.49 124.7 43.21 124.7 C 41.94 124.71 40.82 124.28 39.84 123.44 Z  M 39.56 123.16 L 39.84 123.44 L 39.56 123.16 Z  M 86.83 75.89 L 86.83 75.89 L 39.84 122.88 L 39.84 122.88 L 39.56 123.16 L 39.84 122.88 C 40.68 123.72 41.94 124.14 43.21 124.14 C 44.47 124.14 45.88 123.72 47.42 122.88 L 102.41 91.6 L 102.83 92.02 L 102.41 91.6 L 86.83 75.89 Z ",
    fill: "url(#_lgradient_2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_3",
    x1: -0.19266660263540752,
    y1: -0.5403653420729495,
    x2: 0.41924059215741943,
    y2: 0.07154185271987767,
    gradientTransform: "matrix(62.99,0,0,48.82,39.83,27.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(50,160,113)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.8500000000000005%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(45,167,113)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.620000000000005%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(21,207,116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.08999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(6,231,117)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,240,118)"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: " M 43.2 27.64 C 41.94 27.64 40.68 28.06 39.83 28.9 L 86.83 75.89 L 102.54 60.18 L 47.55 28.9 C 45.87 28.06 44.47 27.64 43.2 27.64 Z  M 43.2 27.07 L 43.2 27.07 L 43.2 27.07 C 44.46 27.07 45.87 27.49 47.41 28.33 L 102.82 59.75 L 102.82 59.75 L 47.41 28.33 C 45.87 27.5 44.47 27.07 43.2 27.07 Z ",
    fill: "url(#_lgradient_3)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: " M 39.84 123.44 L 39.84 123.44 L 39.84 123.44 L 39.84 123.44 Z  M 47.41 123.44 C 46.15 124.14 44.89 124.56 43.76 124.7 C 45.03 124.57 46.15 124.14 47.41 123.44 Z  M 39.56 123.16 L 39.56 123.16 L 39.56 123.16 L 39.56 123.16 Z ",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_4",
    x1: 0.8608439924302573,
    y1: -0.20791497885195476,
    x2: -0.5003037022551999,
    y2: 1.153232715833502,
    gradientTransform: "matrix(63.41,0,0,33.1,39.69,91.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(204,46,54)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(156,14,78)"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: " M 102.54 91.6 L 47.55 122.88 C 46.01 123.72 44.6 124.14 43.34 124.14 C 42.08 124.14 40.82 123.72 39.97 122.88 L 39.69 123.16 L 39.69 123.16 L 39.97 123.44 L 39.97 123.44 L 39.97 123.44 C 40.81 124.28 42.07 124.7 43.34 124.7 C 43.62 124.7 43.76 124.7 44.04 124.7 C 45.16 124.56 46.42 124.14 47.69 123.44 L 103.1 92.02 L 102.54 91.6 Z ",
    fill: "url(#_lgradient_4)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: " M 37.87 117.83 L 37.87 117.83 C 37.87 120.21 38.57 122.04 39.69 123.16 L 39.69 123.16 L 39.69 123.16 L 39.69 123.16 C 38.44 122.04 37.87 120.22 37.87 117.83 Z ",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_5",
    x1: 31.6355947476174,
    y1: -10.622750575551308,
    x2: 8.881377941606903,
    y2: 12.131466230459182,
    gradientTransform: "matrix(2.1,0,0,5.89,37.87,117.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,141,224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.657445%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,141,224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.009999999999998%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,167,224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,184,224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.03999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,196,224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,199,224)"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: " M 37.87 117.27 L 37.87 117.83 C 37.87 120.21 38.57 122.04 39.69 123.16 L 39.97 122.88 L 39.69 122.6 C 38.44 121.48 37.87 119.66 37.87 117.27 Z ",
    fill: "url(#_lgradient_5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_6",
    x1: 166.32766075001084,
    y1: 0.8240723997339965,
    x2: -51.63305376127158,
    y2: 218.78478691101637,
    gradientTransform: "matrix(0.28,0,0,0.28,39.56,122.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(224,51,60)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(171,15,86)"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: " M 39.84 122.88 L 39.56 123.16 L 39.56 123.16 L 39.84 122.88 L 39.84 122.88",
    fill: "url(#_lgradient_6)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: " M 125.4 75.89 L 125.4 75.89 C 125.4 76.59 125.26 77.43 124.84 78.13 C 125.26 77.43 125.4 76.59 125.4 75.89 Z ",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_7",
    x1: 1.1272389645823937,
    y1: 0.5001145244885254,
    x2: -2.885280372540426,
    y2: 0.500114524488525,
    gradientTransform: "matrix(22.87,0,0,16.13,102.53,75.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(224,197,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(224,166,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.53999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(224,145,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(224,137,0)"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: " M 125.4 75.89 C 125.12 77.71 123.86 79.4 121.47 80.8 L 102.53 91.6 L 102.95 92.02 L 121.47 81.5 C 123.15 80.52 124.28 79.4 124.84 78.27 C 125.26 77.43 125.4 76.59 125.4 75.89 Z ",
    fill: "url(#_lgradient_7)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_8",
    x1: -3256.76445150371,
    y1: 0.7085808157751672,
    x2: -3256.7648057393326,
    y2: 0.7089350513977054,
    gradientTransform: "matrix(0.28,0,0,0.28,102.54,91.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(224,51,60)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(171,15,86)"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: " M 102.54 91.6 L 102.54 91.6 L 102.82 91.88 L 102.54 91.6",
    fill: "url(#_lgradient_8)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: " M 102.82 59.9 L 102.82 59.9 L 102.82 59.9 L 121.34 70.42 C 124.01 71.96 125.27 73.93 125.27 75.89 L 125.27 75.89 C 125.27 73.93 124.01 71.96 121.34 70.42 L 102.82 59.9 Z  M 37.87 33.25 L 37.87 33.25 L 37.87 33.25 Z  M 37.87 33.25 L 37.87 33.25 L 37.87 33.25 Z  M 43.2 27.07 C 40.25 27.07 38.15 29.31 37.87 33.24 C 38.01 31.28 38.57 29.73 39.55 28.61 L 39.83 28.33 L 39.83 28.33 C 40.68 27.5 41.94 27.07 43.2 27.07 Z ",
    fill: "rgb(64,64,64)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_9",
    x1: 11.254688571429359,
    y1: -3.1041528454999394,
    x2: -12.946986736616967,
    y2: 21.09752246254638,
    gradientTransform: "matrix(1.96,0,0,5.89,37.88,28.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,184,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.657445%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,185,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.009999999999998%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,206,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,221,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.03999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,231,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,234,255)"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: " M 39.56 28.62 L 39.56 28.62 C 38.58 29.6 38.02 31.29 37.88 33.25 L 37.88 33.25 L 37.88 33.25 L 37.88 33.25 L 37.88 33.25 C 37.88 33.53 37.88 33.67 37.88 33.95 L 37.88 34.51 C 37.88 31.99 38.58 30.02 39.84 28.9 L 39.56 28.62 Z  M 39.84 28.34 L 39.84 28.34 L 39.84 28.34 L 39.84 28.34 Z ",
    fill: "url(#_lgradient_9)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_10",
    x1: 1.1334442894618313,
    y1: 0.49987503099814745,
    x2: -2.8793795059030787,
    y2: 0.49987503099814695,
    gradientTransform: "matrix(22.87,0,0,16.13,102.4,59.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,232,64)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,206,64)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.53999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,188,64)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,181,64)"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: " M 102.82 59.9 L 102.4 60.32 L 121.34 71.12 C 123.72 72.52 125.13 74.21 125.27 76.03 C 125.27 74.07 124.01 72.1 121.34 70.56 L 102.82 59.9 L 102.82 59.9 Z ",
    fill: "url(#_lgradient_10)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_11",
    x1: -0.18738848269328767,
    y1: -0.7969980664652994,
    x2: 0.42181073020382265,
    y2: -0.18779885356818882,
    gradientTransform: "matrix(63.27,0,0,33.1,39.55,27.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(101,184,149)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.8500000000000005%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(98,189,149)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.620000000000005%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(80,219,151)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.08999999999999%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(68,237,152)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(64,244,152)"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: " M 43.2 27.07 L 43.2 27.07 C 41.94 27.07 40.68 27.49 39.83 28.33 L 39.83 28.33 L 39.55 28.61 L 39.83 28.89 C 40.67 28.05 41.93 27.63 43.2 27.63 C 44.46 27.63 45.87 28.05 47.41 28.89 L 102.4 60.17 L 102.82 59.75 L 102.82 59.75 L 47.41 28.33 C 45.87 27.5 44.47 27.07 43.2 27.07 Z ",
    fill: "url(#_lgradient_11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoplaystore);
export default __webpack_public_path__ + "static/media/logoplaystore.87988b2fec1e3b18eafaf26c3107f44e.svg";
export { ForwardRef as ReactComponent };